import React, { useState, useContext, useEffect } from "react";
import { UserContext } from "../../context/userContext";
import { useParams } from 'react-router-dom';
import { ContentDetailsCompanyContainer, Image } from "./ContentDetailsCompanyStyled";

import { FormattedMessage, useIntl } from 'react-intl';
import photoVideo from './../../utils/images/photo_video.svg';

import { patchCollaboration, putContentCollaboration, putContentCollaborationStatus } from "../../api/collaborationApi";
import Spinner from "../Spinner/Spinner";
import Select from 'react-select';
import { contentCollaborationsStatusCompany } from "../../utils/constants/general";


export default function ContentDetailsCompany({ subItem, type, setShowDispute, activeIndex, setActiveIndex, setShowCarousel, setContentIndex, contentIndex, contentType, setContentType }) {

    const intl = useIntl();
    const { idCollaboration } = useParams();

    const [status, setStatus] = useState(parseFloat(subItem?.split(" - ")[2]));
    const [content, setContent] = useState(subItem?.split(" - ")[1]);
    const [idContent, setIdContent] = useState(subItem?.split(" - ")[0]);

    const { userToken } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    const isAdmin = sessionStorage.getItem('isAdmin');
    const [statusIndex, setStatusIndex] = useState(status - 1);

    const [statusOptions, setStatusOptions] = useState(contentCollaborationsStatusCompany);

    const [contentValue, setContentValue] = useState();

    useEffect(() => {
        const statusUpdate = [];
        setStatusIndex(status - 1);
        setContentValue(statusOptions[status - 1]);
        if (status === 3) {
            statusOptions.map((status, index) => {
                if (index < 6) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 4) {
            statusOptions.map((status, index) => {
                //Aqui estaba menor que 4
                if (index < 2 || index === 5) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 5) {
            statusOptions.map((status, index) => {
                if (index < 3 || index === 5) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 6) {
            statusOptions.map((status, index) => {
                if (index < 6) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else if (status === 7) {
            statusOptions.map((status, index) => {
                if (index < 7) {
                    statusUpdate.push({ ...status, isDisabled: true })
                } else {
                    statusUpdate.push({ ...status })
                }
            })
        } else {
            statusOptions.map((status) => {
                statusUpdate.push({ ...status, isDisabled: true })
            })
        }

        setStatusOptions(statusUpdate);
    }, [status])

    const handlerApproveContent = () => {
        const collaborationBody = {
            readinfluencer: false
        }

        patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody })

        putContentCollaborationStatus({ contentId: idContent, newStatus: 5, token: userToken }).then((response) => {
            if (response.status === 200) {
                setStatus(5)
            }
        })
    }

    const handlerRequestModification = () => {
        setIsLoading(true)
        putContentCollaborationStatus({ contentId: idContent, newStatus: 3, token: userToken }).then((response) => {
            if (response.status === 200) {
                setStatus(3)
            }
            const contentBody = {
                itemId: idContent,
                content: "empty"
            }
            const collaborationBody = {
                readinfluencer: false
            }

            patchCollaboration({ collaborationId: idCollaboration, collaborationBody: collaborationBody })

            putContentCollaboration({ contentBody: contentBody, token: userToken }).then((response) => {
                setIsLoading(false)
                if (response.status === 202) {
                    setContent('empty')
                }

            })
        })
    }

    const adminChangeStatus = ({ newStatus }) => {
        setIsLoading(true);
        if (newStatus === 7) {
            setIsLoading(false);
            setShowDispute(true);
        } else {
            putContentCollaborationStatus({ contentId: idContent, newStatus: newStatus, token: userToken }).then((response) => {
                setIsLoading(false);
                if (response.status === 200) {
                    setStatus(newStatus)
                } else if (response.status === 409) {
                    window.alert("You don't have permissions to do that action")
                }
            })
        }
    }

    const selectStyles = {
        control: (styles) => ({
            ...styles, borderRadius: '10px',
            boxShadow: 'none', height: '30px', minHeight: '34px', flexWrap: 'no-wrap', width: '180px'

        }),
        menu: (styles) => ({
            ...styles, display: 'flex'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        input: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        placeholder: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        singleValue: (styles) => ({
            ...styles, fontSize: '1.3rem', "@media(max-width: 2400px)": {
                fontSize: '1.2rem'
            },
            "@media(max-width: 1440px) and (max-height: 1920px)": {
                fontSize: '1.1rem'
            },
            "@media(max-width: 1366px)": {
                fontSize: '1rem'
            }
        }),
        dropdownIndicator: (styles) => ({
            ...styles, color: '#E8339E'
        }),
        menuList: (styles) => ({
            ...styles, width: '180px'
        })
    };

    return (
        <ContentDetailsCompanyContainer>

            {(JSON.parse(isAdmin) === true) ? (
                <div className="adminSelect">
                    <Select options={statusOptions}
                        styles={selectStyles}
                        placeholder={intl.formatMessage({ id: "collaboracion_status_title" })}
                        //defaultValue={statusOptions[statusIndex]}
                        value={contentValue}
                        onChange={(event) => {
                            adminChangeStatus({ newStatus: event.value })
                        }} />
                </div>) : (
                <div className="statusContainer">
                    {(status === 1) ? (<div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_company_1" defaultMessage="Aceptación pendiente" /></p>
                    </div>

                    ) : (status === 2) ? (<div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_company_2" defaultMessage="Declinado (cerrado)" /></p>
                    </div>
                    ) : (status === 3) ? (
                        <div className="statusTextContainer">
                            <p className="status"><FormattedMessage id="collaboration_details_status_company_3" defaultMessage="Creando contenido" /></p>
                        </div>
                    ) : (status === 4) ? (<div className="statusTextContainer">
                        <div className="status statusButton">
                            <p onClick={handlerApproveContent}><FormattedMessage id="collaboration_details_status_company_4_a" defaultMessage="Aprueba contenido" /> /</p>
                            <p onClick={handlerRequestModification}><FormattedMessage id="collaboration_details_status_company_4_b" defaultMessage="Solicita modificación" /></p>
                        </div>
                    </div>
                    ) : (status === 5) ? (
                        <div className="statusTextContainer">
                            <p className="status"><FormattedMessage id="collaboration_details_status_company_5" defaultMessage="Publicando contenido" /></p>
                        </div>
                    ) : (status === 6) ? (<div className="statusTextContainer">
                        <p className="status statusButton" onClick={() => setShowDispute(true)}><FormattedMessage id="collaboration_details_status_company_6" defaultMessage="Ventana de disputa" /></p>
                    </div>
                    ) : (status === 7) ? (
                        <div className="statusTextContainer">
                            <p className="status"><FormattedMessage id="collaboration_details_status_company_7" defaultMessage="En espera" /></p>
                        </div>
                    ) : (status === 8) ? (
                        <div className="statusTextContainer">
                            <p className="status"><FormattedMessage id="collaboration_details_status_company_8" defaultMessage="Terminado" /></p>
                        </div>
                    ) : (status === 9) && (<div className="statusTextContainer">
                        <p className="status"><FormattedMessage id="collaboration_details_status_influencer_9" defaultMessage="Cancelado" /></p>
                    </div>
                    )}
                </div>
            )}

            {(content === 'empty') ? (
                <div className="notContent">
                    <img src={photoVideo} alt="video" />
                </div>
            ) : (
                <div className="content"  >
                    {(type === 'photo') ? (<>{/* <a href={content} download> */}
                        <Image image={content} onClick={() => {
                            setActiveIndex(activeIndex)
                            setContentIndex(contentIndex);
                            setContentType(contentType);
                            setShowCarousel(true);
                        }} />
                        {/* </a> */} </>) : (
                        <>
                            {/* <a href={content} download> */}
                            <video
                                className="video"
                                //controls
                                src={content}
                                onClick={() => {
                                    setActiveIndex(activeIndex)
                                    setContentIndex(contentIndex);
                                    setContentType(contentType);
                                    setShowCarousel(true);
                                }}
                            />
                            {/* </a>  */}
                        </>
                    )}

                </div>
            )}

            {(isLoading) && (<Spinner />)}

        </ContentDetailsCompanyContainer>
    )
}